module.exports = __webpack_public_path__ + "static/media/sc_22_i.ac7b748f.png";